import AttributeSelector from "./AttributeSelector";

export default AttributeSelector;
